"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCookie = getCookie;
exports.getCsrfToken = void 0;
const CSRF_TOKEN_KEY = "csrftoken";
function getCookie(name) {
  if (typeof document === "undefined" || !name) {
    return "";
  }
  return document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`))?.[2] || "";
}
const getCsrfToken = () => {
  return getCookie(CSRF_TOKEN_KEY);
};
exports.getCsrfToken = getCsrfToken;